'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATUS = exports.STATUS = 'status';
var MESSAGE_DELETED_STATUS = exports.MESSAGE_DELETED_STATUS = 'messageDeletedStatus';